<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-6">
      <add-category> </add-category>
    </div>
  </div>
</template>
<script>
import AddCategory from "./Add/AddCategory.vue";

export default {
  components: {
    AddCategory,
  },
};
</script>
<style></style>
